import React from "react";
import { SlidersHorizontal, ChevronDown } from "lucide-react";

/**
 * Phone-only "Filters (n)" button.
 *
 * Filter panels keep their normal layout on tablet/desktop — this button is
 * hidden there by `.nx-filters-toggle` in styles/responsive.css. On phones the
 * panel's grid gets `className="nx-filter-grid"` + `data-open={open}` and
 * every field except the search gets `nx-filter-extra`, so the long stack of
 * dropdowns collapses behind this button instead of pushing the data a full
 * screen down. Pure presentation: it never touches the filter values.
 */
const MobileFilterToggle = ({ open, onToggle, activeCount = 0, language = "en", theme = "dark" }) => {
  const isAr = language === "ar";
  const dark = theme === "dark";
  const label = open ? (isAr ? "إخفاء الفلاتر" : "Hide filters") : isAr ? "الفلاتر" : "Filters";

  return (
    <button
      type="button"
      className="nx-filters-toggle"
      onClick={onToggle}
      aria-expanded={open}
      style={{
        alignItems: "center",
        gap: "8px",
        minHeight: "40px",
        padding: "0 14px",
        borderRadius: "10px",
        border: dark ? "1px solid rgba(255,255,255,0.14)" : "1px solid rgba(15,23,42,0.12)",
        background: open ? (dark ? "rgba(59,130,246,0.18)" : "rgba(37,99,235,0.08)") : "transparent",
        color: dark ? "#e2e8f0" : "#1e293b",
        fontSize: "14px",
        fontWeight: 600,
        cursor: "pointer",
        fontFamily: "inherit",
      }}
    >
      <SlidersHorizontal size={16} aria-hidden="true" />
      <span>{label}</span>
      {activeCount > 0 && (
        <span
          style={{
            minWidth: "20px",
            height: "20px",
            padding: "0 6px",
            borderRadius: "10px",
            background: "#3b82f6",
            color: "#fff",
            fontSize: "12px",
            fontWeight: 700,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {activeCount}
        </span>
      )}
      <ChevronDown
        size={16}
        aria-hidden="true"
        style={{ transition: "transform .2s ease", transform: open ? "rotate(180deg)" : "none" }}
      />
    </button>
  );
};

export default MobileFilterToggle;
